export default {"src":"/_next/static/media/face_verification.239e44ff.svg","height":223,"width":199,"blurWidth":0,"blurHeight":0};